import React from 'react';
import { Typography, Divider, Box } from '@mui/material';
import { parse_date } from '../../helpers';

import { List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { FilterAlt } from '@mui/icons-material';

const formatFilterValue = (value) => {
  if (Array.isArray(value)) {
    // If it's an array of objects with name fields
    if (value.length > 0 && value.every(obj => typeof obj === 'object' && obj.name)) {
      return value.map(obj => obj.name).join(', ');
    }
    // Otherwise treat as regular array
    return value.join(', ');
  }
  if (typeof value === 'object' && value !== null) {
    return Object.entries(value)
      .map(([key, val]) => {
        if (Array.isArray(val) && val.length > 0 && val.every(obj => typeof obj === 'object' && obj.name)) {
          // Handle array of objects with name fields
          return `${key}: ${val.map(obj => obj.name).join(', ')}`;
        }
        if (val && typeof val === 'object') {
          // If the object has a name property, use that
          if (val.name) {
            return `${key}: ${val.name}`;
          }
          // Otherwise fall back to joining all values
          return `${key}: ${Object.values(val).join(', ')}`;
        }
        return `${key}: ${Array.isArray(val) ? val.join(', ') : val}`;
      })
      .join('; ');
  }
  return value;
};

const CohortDetails = ({ cohortData }) => {
  if (!cohortData) {
    return <Typography>No cohort data available.</Typography>;
  }


  const formattedDate = cohortData.creationDate
    ? parse_date(new Date(cohortData.creationDate))
    : 'N/A';

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {cohortData.cohortName}
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Created: {formattedDate}
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="body2" gutterBottom>
        Description:  {cohortData.description || 'No description provided.'}
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Typography variant="body2" gutterBottom>
        Patients : <strong>{cohortData.total_patients} </strong>, Experiments: <strong>{cohortData.data.length}</strong>
      </Typography>
      {/* <List dense>
        {cohortData.data.map((patient, index) => (
          <ListItem key={index}>
            <ListItemText primary={patient} />
          </ListItem>
        ))}
      </List> */}

      <Divider sx={{ my: 2 }} />

      <Typography variant="body2" gutterBottom>
        Filters:
      </Typography>
      <List dense>
        {cohortData.filters.map((filter, index) => (
          <ListItem key={index}>
          <ListItemIcon>
            <FilterAlt /> {/* Add the filter icon here */}
          </ListItemIcon>
          <ListItemText
            primary={`${filter.key}`}
            secondary={formatFilterValue(filter.val)}
          />
        </ListItem>
        ))}
      </List>

      <Divider sx={{ my: 2 }} />

      {/* <Box>
        <Typography variant="subtitle1" gutterBottom>
          Cohort ID: {cohortData.id}
        </Typography>
      </Box> */}
  </Box>
  );
};

export default CohortDetails;